import { Id, LaravelResponse, keyToUrl, withIndexEndpoint, withShowEndpoint, withUpdateEndpoint } from "@dgs/core";
import axios from "axios";
import {
	EventDetailResource,
	EventIndexResource,
	EventOffboardingSaveRequest,
	EventSaveRequest,
	EventUpdateResource,
	SimilarEventRequest,
} from "../types/event";
import { UserResponsibilityResource } from "../types/userResponsibility";

const baseKey = ["events"];
const similarEventsKey = [...baseKey, "similar"];
const detailsKey = (eventId: Id) => [...baseKey, `${eventId}`, "details"];
const userResponsibilityKey = (eventId: Id) => [...baseKey, `${eventId}`, "user-responsibilities"];
const eventOffboardingKey = (eventId: Id) => [...baseKey, `${eventId}`, "offboarding"];

export const eventService = {
	...withIndexEndpoint<EventIndexResource>(baseKey),
	...withShowEndpoint<EventUpdateResource>(baseKey),
	...withUpdateEndpoint<EventSaveRequest>(baseKey),
	baseKey,
	similarEventsKey,
	getSimilarEvents: (request: SimilarEventRequest) =>
		axios.post<LaravelResponse<EventIndexResource[]>>(keyToUrl(similarEventsKey), request),
	detailsKey,
	getDetails: (eventId: Id) => axios.get<LaravelResponse<EventDetailResource>>(keyToUrl(detailsKey(eventId))),
	userResponsibilityKey,
	getUserResponsibilityOptions: (eventId: Id, search: string, page: number) =>
		axios.get<LaravelResponse<UserResponsibilityResource[]>>(keyToUrl(userResponsibilityKey(eventId)), {
			params: { search, page },
		}),
	offboardEvent: (eventId: Id, request: EventOffboardingSaveRequest) =>
		axios.put(keyToUrl(eventOffboardingKey(eventId)), request),
};
